import { SyncModeEnum } from './sync-mode.enum';

export class MailChimpSync {
  public SyncMode: SyncModeEnum;
  public ListName: string;
  public ListId: string;
  public ProfileIds: number[];
  public UnsubscribeExistingMembers: boolean;

  public constructor() {
    this.SyncMode = SyncModeEnum.Full;
    this.ListName = '';
    this.ListId = '';
    this.ProfileIds = new Array<number>();
    this.UnsubscribeExistingMembers = false;
  }
}
